export const eventNames = {
  loginSuccess: "login_success",
  logout: "logout",
  onboardingPageView: "onboarding_page_view",
  onboardingStepSubmitted: "onboarding_step_submitted",
  dashboardView: "dashboard_view",
  dashboardCardClicked: "dashboard_card_clicked",
  dashboardFilterChanged: "dashboard_filter_changed",
  paymentInitiated: "payment_initiated",
  paymentSuccess: "payment_success",
  paymentFailed: "payment_failed",
  maintenancePageShown: "maintenance_page_shown",
  certificateDisclaimerAcknowledged: "certificate_disclaimer_acknowledged",
  tinValidationResult: "tin_validation_result",
} as const;

export type EventName = (typeof eventNames)[keyof typeof eventNames];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackEvent(
  posthog: any | null,
  name: EventName,
  properties?: Record<string, unknown>,
) {
  if (!posthog) return;
  posthog.capture(name, properties);
}

// Small helpers to keep person/group properties consistent
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildEmployerPersonProperties(currentEmployer: any) {
  if (!currentEmployer) return {};

  const user = currentEmployer.user ?? {};

  return {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    employerCode: currentEmployer.employerCode,
    companyName: currentEmployer.companyName,
    employerType: currentEmployer.employerType,
    sector: currentEmployer.sector,
    registrationStatus: currentEmployer.registrationStatus,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildEmployerGroupProperties(currentEmployer: any) {
  if (!currentEmployer) return {};

  return {
    employerCode: currentEmployer.employerCode,
    companyName: currentEmployer.companyName,
    employerType: currentEmployer.employerType,
    sector: currentEmployer.sector,
    registrationStatus: currentEmployer.registrationStatus,
  };
}
